import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// The form to set the service desk email address of a division
const TicketEmailAddressForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    // The address consists of a prefix and one of the verified email domains
    const fields: FieldType[] = [
        {
            type: 'text',
            name: 'ticket_email_prefix',
            label: 'ticket.settings.email_prefix_label',
            placeholder: 'ticket.settings.email_prefix_placeholder',
        },
        {
            type: 'dropdown',
            name: 'ticket_email_domain',
            label: 'ticket.settings.email_domain_label',
            apiRequest: [{
                endpoint: 'get_email_domain_list',
                object: 'email_domain',
                params: { verified: true, deleted: false }
            }],
            disabled_selected: 'ticket.settings.email_domain_placeholder',
            allowNoneOption: true,
            showSearch: false,
            optionFormat: 'domain',
            selectionFormat: 'domain',
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject='ticket_email_address'
            fields={fields}
        />
    );
};

export default TicketEmailAddressForm;
